import React from 'react';

import isValid from 'date-fns/isValid';
import { graphql, useFragment } from 'react-relay';

import { StatusTargetDateDisplay } from '../../../../../../../common/ui/status-target-date-display';
import { TargetDate } from '../../../../../../../common/ui/target-date-display';
import type { searchMercuryFocusAreaStatusTargetDate_AtlassianSearchPage$key } from './__generated__/searchMercuryFocusAreaStatusTargetDate_AtlassianSearchPage.graphql';
import { getDisplayedFocusAreaStatus } from './utils';

interface SearchMercuryFocusAreaStatusTargetDateProps {
	node: searchMercuryFocusAreaStatusTargetDate_AtlassianSearchPage$key;
}

export const SearchMercuryFocusAreaStatusTargetDate = ({
	node,
}: SearchMercuryFocusAreaStatusTargetDateProps): React.JSX.Element | null => {
	const data = useFragment(
		graphql`
			fragment searchMercuryFocusAreaStatusTargetDate_AtlassianSearchPage on SearchResult {
				... on SearchResultMercuryFocusArea {
					focusArea {
						status {
							key
							displayName
						}
						health {
							key
							color
							displayName
						}
						targetDate {
							targetDate
							targetDateType
						}
					}
				}
			}
		`,
		node,
	);

	const { displayedStatus, displayedStatusAppearance } = getDisplayedFocusAreaStatus({
		healthColor: data.focusArea?.health?.color,
		statusKey: data.focusArea?.status?.key,
		statusDisplayName: data.focusArea?.status?.displayName,
		healthDisplayName: data.focusArea?.health?.displayName,
		healthKey: data.focusArea?.health?.key,
	});

	if (!displayedStatus) {
		return null;
	}

	const targetDate = data.focusArea?.targetDate?.targetDate;
	const targetDateType = data.focusArea?.targetDate?.targetDateType;
	const displayedTargetDate =
		(targetDate && targetDateType && isValid(new Date(targetDate)) && (
			<TargetDate targetDate={targetDate} targetDateType={targetDateType} />
		)) ||
		undefined;

	return (
		<StatusTargetDateDisplay
			displayedStatus={displayedStatus}
			displayedStatusAppearance={displayedStatusAppearance}
			displayedTargetDate={displayedTargetDate}
		/>
	);
};
